/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpagevoidticket3Inputs */

const en_ticketpagevoidticket3 = /** @type {(inputs: Ticketpagevoidticket3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Void ticket`)
};

const de_ticketpagevoidticket3 = /** @type {(inputs: Ticketpagevoidticket3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket ungültig machen`)
};

/**
* | output |
* | --- |
* | "Void ticket" |
*
* @param {Ticketpagevoidticket3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagevoidticket3 = /** @type {((inputs?: Ticketpagevoidticket3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagevoidticket3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagevoidticket3(inputs)
	return de_ticketpagevoidticket3(inputs)
});
export { ticketpagevoidticket3 as "ticketPageVoidTicket" }